export class LabelConfig {
    ROLE_OPERATOR:string="Operator";
    ROLE_CLUSTER_LEAD:string="Screening Center Manager";
    ROLE_PROGRAM_LEAD:string="Account Admin";
    ROLE_OPTHALMOLOGY_EXPERT:string="Expert";
    ROLE_OPTHALMOLOGY_SUPERVISOR:string="Reading Center Manager";
    ROLE_OPTOMETRIST:string="Optometrist";
}